import { UserRepository } from "../../../api";
import { Report } from "./Report";

export class MensurationReport extends Report {

	constructor(obj = {}) {
		super();

		this.waterTreatmentPoints 					= obj.waterTreatmentPoints || {};
		this.measurementSectorizationPoints = obj.measurementSectorizationPoints || {};
		this.effluentTreatmentPoints 				= obj.effluentTreatmentPoints || {};
		this.inputPoints 										= obj.inputPoints || {};
		this.othersPoints 									= obj.othersPoints || {};

		this.active = false;
	
		this.setColors();
		this.setPoints();
		this.setLabels();

	}

	setColors() {

		const waterTreatmentArray 					= Object.keys(this.waterTreatmentPoints);
		const measurementSectorizationArray = Object.keys(this.measurementSectorizationPoints);
		const effluentTreatmentArray 				= Object.keys(this.effluentTreatmentPoints);
		const inputArray 										= Object.keys(this.inputPoints);
		const othersArray 									= Object.keys(this.othersPoints);

		const waterTreatmentColors = waterTreatmentArray.map(i => {
			return this.getColor(this.waterTreatmentPoints[i]);
		});
		const measurementSectorizationColors = measurementSectorizationArray.map(i => {
			return this.getColor(this.measurementSectorizationPoints[i]);
		});
		const effluentTreatmentColors = effluentTreatmentArray.map(i => {
			return this.getColor(this.effluentTreatmentPoints[i]);
		});
		const inputColors = inputArray.map(i => {
			return this.getColor(this.inputPoints[i]);
		});
		const othersColors = othersArray.map(i => {
			return this.getColor(this.othersPoints[i]);
		});

		this.colors = this.compilateArray({waterTreatmentColors, measurementSectorizationColors, effluentTreatmentColors, inputColors, othersColors});
	}

	setPoints() {

		const waterTreatmentArray 					= Object.keys(this.waterTreatmentPoints);
		const measurementSectorizationArray = Object.keys(this.measurementSectorizationPoints);
		const effluentTreatmentArray 				= Object.keys(this.effluentTreatmentPoints);
		const inputArray 										= Object.keys(this.inputPoints);
		const othersArray 									= Object.keys(this.othersPoints);

		const waterTreatmentPoints = waterTreatmentArray.map(i => {
			return this.getPoints(this.waterTreatmentPoints[i]);
		});
		const measurementSectorizationPoints = measurementSectorizationArray.map(i => {
			return this.getPoints(this.measurementSectorizationPoints[i]);
		});
		const effluentTreatmentPoints = effluentTreatmentArray.map(i => {
			return this.getPoints(this.effluentTreatmentPoints[i]);
		});
		const inputPoints = inputArray.map(i => {
			return this.getPoints(this.inputPoints[i]);
		});
		const othersPoints = othersArray.map(i => {
			return this.getPoints(this.othersPoints[i]);
		});


		this.points = this.compilateArray({waterTreatmentPoints, measurementSectorizationPoints, effluentTreatmentPoints, inputPoints, othersPoints});
	}

	setLabels() {
		const waterTreatmentArray 					= Object.keys(this.waterTreatmentPoints);
		const measurementSectorizationArray = Object.keys(this.measurementSectorizationPoints);
		const effluentTreatmentArray 				= Object.keys(this.effluentTreatmentPoints);
		const inputArray 										= Object.keys(this.inputPoints);
		const othersArray 									= Object.keys(this.othersPoints);

		const allItems = this.compilateArray({waterTreatmentArray, measurementSectorizationArray, effluentTreatmentArray, inputArray, othersArray});

		this.labels = allItems.map(i => {
			switch(i) {
				case "1-1-1" 		: return "Mensuração do uso de água";
				case "1-1-1-2" 	: return "Fontes de captação";
				case "1-2-1-2" 	: return "Métodos de medição";
				case "1-3-1" 		: return "Mensuração de efluente";
				case "1-5-1" 		: return "Controle de insumos";
				case "1-6-2-1" 	: return "Uso de redutores de consumo";
			}
		});
	}

	generateChart(id) {
		this.generateReport(id, this.colors, this.points, this.labels);
	}

	init(auth, id) {
		return {
			colors: this.colors,
			points: this.points,
			labels: this.labels,
			active: false
		};
	}
}


// WEBPACK FOOTER //
// src/models/lib/entities/MensurationReport.js